import { render, staticRenderFns } from "./event.vue?vue&type=template&id=5e0a7c5c&"
import script from "./event.vue?vue&type=script&lang=js&"
export * from "./event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports